import styled from 'styled-components';
import continuousCreationGif from '../../../../assets/images/continuouscreation.gif';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

export const ModalWrapper = styled.div`
  position: relative;
`;

export const CloseButtonWrapper = styled.div`
  position: absolute;
  top: -35px;
  right: -20px;
  z-index: 10;
`;

export const ModalContainer = styled.div`
  width: 452px;
  height: 294px;
  flex-shrink: 0;
  border-radius: 18px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: #1a1a1a;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
`;

export const TopSection = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 20px;
  position: relative;
  padding: 20px;
`;

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  padding-bottom: 10px;
`;

export const CongratsText = styled.p`
  color: #fff;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 0;
`;

export const PackageTitle = styled.h2`
  color: #fff;
  font-size: 20px;
  font-style: normal;
  font-weight: 900;
  line-height: normal;
  margin: 5px 0;
`;

export const PackageTitleBig = styled.h2`
  color: #fff;
  font-size: 30px;
  font-style: normal;
  font-weight: 900;
  line-height: normal;
  margin: 5px 0;
`;
export const UnderlineSvg = styled.svg`
  width: 211.259px;
  height: 15.181px;
  flex-shrink: 0;
  position: absolute;
  bottom: 0;
  left: 0;
  transform: rotate(3.414deg);
`;

export const AnimationContainer = styled.div`
  width: 104px;
  height: 104px;
  flex-shrink: 0;
  aspect-ratio: 1/1;
  background: url(${continuousCreationGif}) no-repeat center center;
  background-size: contain;
`;

export const BottomSection = styled.div`
  height: 84px;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  flex-shrink: 0;
  border-bottom-left-radius: 18px;
  border-bottom-right-radius: 18px;
`;

export const RewardText = styled.p`
  color: #fff;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 0;
`;

export const HighlightNumber = styled.span`
  color: #ff6b35; /* 主题色 - 橙色 */
  font-weight: 600; /* 稍微加粗突出显示 */
`;

export const ActionButton = styled.button`
  display: flex;
  width: 120px;
  height: 40px;
  padding: 10px 20px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  border-radius: 8px;
  background: linear-gradient(123deg, #feae45 19.66%, #ff6d49 67.36%);
  border: none;
  cursor: pointer;
  color: #fff;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.9;
  }

  &:active {
    opacity: 0.8;
  }
`;

export const ButtonIcon = styled.svg`
  width: 14px;
  height: 14px;
  flex-shrink: 0;
`;
